<template>
  <div id="app">
    <v-app style="background-color: #F8F8F8">
      <router-view></router-view>
    </v-app>
  </div>
</template>

<script>
export default {
  mounted() {
    this.$fbCustomerChat.setOptions({
      theme_color: "#EF3E2D",
    });
  },
};
</script>

<style>
#app {
  font-family: Prompt, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>
